export default (theme) => ({
  asterisk: {
    color: '#cd2026',
  },
  labelText: {
    color: theme.palette.font.main,
  },
});
